module.exports = __webpack_public_path__ + "static/exo-v6-latin-regular-e9e086790f8c2ed4d82af51b404c4b80.woff2";